var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEquipManager = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 82 81",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-11323,-529)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10440,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Equip-manager",
    transform: "matrix(1,-0,-0,1,883.047,529)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 22.918,
    y: 0.163,
    width: "36px",
    height: "81px"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "36px",
    height: "81px",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAABRCAYAAAC67wTqAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAC30lEQVRoge2aTahVVRSAv7VNDQvk2UuSKAPB9JFiSBANbFKSIiIEIuQ8HCWIU9FRjmtik+a+USD0M2geqBUWkQN7JhSJGYXkz3vd+zk4nsfjPXNfveeefZHzje49XO76zmbvs9Ze+0AGda16Wr3to9NTv1V35OJlUafV/hAyC/kpFy8GELoDrBj6zip6EfHEsEI2JFMFjHhgzNRksCbohHIMIjTbYLxe7geDCH3ZgEjNpaH/QV2nfqbeGeL501MvqG83cFMdHY8R6qT6oTo7XJKf52t1g5rNofeTeV79viGRhVxX9z+szBvqnyOQqbmtHlIfWIrUMi+oN0YoUzOn7s3JTKjftSBTc0N96/9kkvpRizI159SlFam6U/2vgFBfPVZ7xAKhM8Ce7CQbDX1gY0RcSvdk1gLvFJKBqgzaV38AOAnkl+Bo2Q8Q6hrgN+DJsj4AbE7Adprbdw3LkQRMMj7F/pYE3AQa3QwOwdVQ1wM/U34OCexKEfErcBSYKyw0HRFfAaCG+r76b4En9Zx6Sn1miaL6mvp7izJ99QPvV7Cp29W/WpSpuakeXCzztPpDAZmavrobIFkN18fAK83P04EJ4ISaQn2JatmvLCgE1bLfnYBNwPLCMlCN0oEErGF8UsdUoiqOxiV1zCbgKpXUOHA+1GeBy8CqwjJ94NUUEdeAE5QfpTMRcSEArHaQnwOlOlw9YFtE/Dh/RX1R/cKq/dYmF9XXlyhabRSn1F9alOmp76nLF8uE+qnNtV0eVuqsuqWWWaZ+UkBkMd+oK0PdCpxjPNLHoQRspPwmsebdBDzFAMdULfHcuCTVeTqhHJ1Qjk4oRyeUoxPK0Qnl6IRydEI5OqEcnVCOTijHWAqVPnRZyK0E/MEAL6u1xNlQVwMzwERhmVlgU4qIf4CdwPXCQscjYmb+m/qm1WsPf9tOW69vdRJ0UT2sJljU9VAngJeB1cCyEY+IVOe9MxFxpb54F/b32XrG8UyHAAAAAElFTkSuQmCC"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEquipManager);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Equip_manager.b22f6674bda638ebac3b63dd9ed9ae36.svg";